// This is a usability check only. The server must verify every protected request.
export function sessionExpiresAt(token: string | null): number | null {
  if (!token) return null;
  try {
    const parts = token.split('.');
    if (parts.length !== 3 || parts.some(part => !/^[A-Za-z0-9_-]+$/.test(part) || part.length % 4 === 1)) return null;
    const decode = (part: string) => JSON.parse(atob(part.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat((4 - part.length % 4) % 4)));
    const header = decode(parts[0]);
    const payload = decode(parts[1]);
    const valid = !!header && typeof header === 'object' && !Array.isArray(header) &&
      !!payload && typeof payload === 'object' && !Array.isArray(payload) &&
      typeof payload.exp === 'number' && Number.isFinite(payload.exp) && Number.isFinite(payload.exp * 1000);
    return valid ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

export function hasUsableSession(token: string | null): boolean {
  const expiry = sessionExpiresAt(token);
  return expiry !== null && expiry > Date.now();
}

export const SESSION_ENDED = 'sf-dashboard-session-ended';

export function endSession(token: string | null): void {
  if (!token || localStorage.getItem('token') !== token) return;
  localStorage.removeItem('token');
  window.dispatchEvent(new Event(SESSION_ENDED));
}
